import Swal from "sweetalert2";

const buildBankTransferHtml = ({
    bankDetails,
    orderId,
    paymentMethod,
}) => {
    if (paymentMethod !== "BankTransfer") {
        return "";
    }

    if (!bankDetails) {
        return `
      <div
        dir="rtl"
        style="
          margin-top:15px;
          color:#b26a00;
          text-align:right;
        "
      >
        ההזמנה התקבלה, אך לא הצלחנו להציג כרגע את
        פרטי החשבון. הפרטים יישלחו אלייך במייל.
      </div>
    `;
    }

    return `
    <div
      dir="rtl"
      style="
        margin-top:18px;
        padding:16px;
        border:1px solid #d9dee3;
        border-radius:10px;
        background:#f7f9fb;
        text-align:right;
        line-height:1.9;
      "
    >
      <div
        style="
          font-size:18px;
          font-weight:700;
          margin-bottom:10px;
        "
      >
        פרטי חשבון להעברה בנקאית
      </div>

    <div>
  <strong>בנק:</strong>
  ${bankDetails.bankNumber || ""}
  ${bankDetails.bankNumber && bankDetails.bankName
            ? ` - ${bankDetails.bankName}`
            : bankDetails.bankName || ""
        }
</div>

<div>
  <strong>סניף:</strong>
  ${bankDetails.branchNumber || ""}
</div>

<div>
  <strong>חשבון:</strong>
  ${bankDetails.accountNumber || ""}
</div>

<div>
  <strong>בעל החשבון:</strong>
  ${bankDetails.accountHolder || ""}
</div>

      <div
        style="
          margin-top:14px;
          padding-top:12px;
          border-top:1px solid #d9dee3;
        "
      >
        בעת ביצוע ההעברה יש לציין בהערה:
        <strong> הזמנה מספר ${orderId || ""}</strong>
      </div>

      <div style="margin-top:10px;">
        לאחר ביצוע ההעברה יש לשלוח אלינו אסמכתא
        בצירוף מספר ההזמנה ושם לקוח
      </div>

      <div>
        <strong>מייל לשליחת אסמכתא:</strong>
        ${bankDetails.referenceEmail || ""}
      </div>

      <div>
        <strong>טלפון לשליחת אסמכתא:</strong>
        ${bankDetails.referencePhone || ""}
      </div>

      <div
        style="
          margin-top:12px;
          color:#a76300;
          font-weight:700;
        "
      >
        ההזמנה תועבר לטיפול לאחר קבלת התשלום
        ואימות האסמכתא.
      </div>
    </div>
  `;
};

export const showOrderSuccessAlert = async ({
    orderId,
    total,
    paymentMethod,
    bankDetails,
}) => {
    const bankTransferHtml = buildBankTransferHtml({
        bankDetails,
        orderId,
        paymentMethod,
    });
    let paymentMessage = "";

    switch (paymentMethod) {
        case "BankTransfer":
            paymentMessage =
                "נציג יצור איתך קשר למסירת פרטי הבנק.";
            break;

        case "TicketCard":
            paymentMessage =
                "נציג יצור איתך קשר לקבלת מספר וקוד הכרטיס.";
            break;

        case "PhonePayment":
            paymentMessage =
                "נציג יצור איתך קשר טלפונית להשלמת ההזמנה.";
            break;

        default:
            paymentMessage = "";
            break;
    }

    await Swal.fire({
        title: "ההזמנה התקבלה בהצלחה",
        html: `
      <div
        dir="rtl"
        style="
          line-height:1.8;
          text-align:right;
        "
      >
        ${orderId
                ? `
              <div>
                <strong>מספר הזמנה: ${orderId}</strong>
              </div>
            `
                : ""
            }

        <div>סיכום ההזמנה נשלח אלייך למייל.</div>
        ${paymentMessage
                ? `<div style="margin-top:8px;">${paymentMessage}</div>`
                : ""
            }
       

        <div style="margin-top:10px;">
          <strong>
            סה"כ לתשלום: ₪${Number(total || 0).toFixed(2)}
          </strong>
   
    `,
        icon: "success",
        confirmButtonColor: "#58A76B",
        confirmButtonText: "סיום",
        width: paymentMethod === "BankTransfer" ? 650 : 500,
        customClass: {
            popup: "custom-swal",
        },
    });
};